/*
 * En-tête de section/page admin : titre serif + sous-titre + slot d'actions,
 * reproduit le style des sections de l'ancien dashboard.
 */
const PageHeader = ({ title, subtitle, actions, rule = false }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-4">
    <div className="flex-1 flex items-center gap-3">
      <div>
        <h2
          className="text-2xl text-slate-900"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 500 }}
        >
          {title}
        </h2>
        {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
      </div>
      {rule && <div className="flex-1 h-px bg-slate-200" />}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
